import dayjs from 'dayjs';
import React from 'react';
import './css/postCard.scss';
import relativeTime from 'dayjs/plugin/relativeTime';
import LazyImage from '../../../../components/CustomLibraries/LazyImage';
import { reactHtmlParser } from '../../../../common/common';

const PostCard = ({ data, channelName, channelLogo }) => {
  dayjs.extend(relativeTime);
  return (
    <div className="w-100 shadow rounded postCard">
      <div className="d-flex align-items-center postCardTop py-3 px-4 border-bottom border-light">
        <div className="rounded-circle postCardPic overflow-hidden">
          <LazyImage src={channelLogo} className="object-fit-cover w-100 h-100 float-start" logo />
        </div>
        <div className="postCardTopRight ps-3">
          <h4 className="fw-semibold text-black fs-16">{channelName}</h4>
          {data?.post_date && (
            <span className="fs-5 text-dark d-block mt-1">
              Posted {dayjs(data?.post_date).fromNow()}
            </span>
          )}
        </div>
      </div>
      <div className="w-100 fs-4 fw-medium postCardContent py-3 px-3">
        <p>{reactHtmlParser(data?.value)}</p>
      </div>
    </div>
  );
};

export default PostCard;
